import configs from 'configs';
import { authHeaders } from 'functions/authHeader';
import request from 'functions/api/request';

const apiUrl = configs.beApiUrl;

export const sendContactUs = async (data) => {
  let response = null;

  const requestOptions = {
    url: `${apiUrl}/public/email/contactus`,
    headers: await authHeaders(),
    data,
    json: true,
  };

  try {
    response = await request.post(requestOptions);
  } catch (ex) {
    console.error('Error occurred, while trying to send contact us info', ex);
    throw ex;
  }

  return response;
};
